module.exports = __webpack_public_path__ + "static/media/solution_mindset_34bi.fb8efd35.svg";